
export const defaultRangeData = [
    { text: "Use The",
      code: ".Range-Slider" 
    },
    { text: "Class. And lagos Used Ion Range Slider.",
      code: "[Http://Ionden.Com/A/Plugins/Ion.RangeSlider]" 
    },
];
